import { useTranslation } from "react-i18next";
import { useWindowSize } from "@uidotdev/usehooks";
import { Question, QuickStart } from "../../../components/common";
import { Features, Headerkeyfeatures } from "../../../components/bioatendance";
import { Link } from "react-router-dom";
import choose1 from "../../../assets/img/products/facialsensevisitormanagement/choose.png";
import multiple from "../../../assets/img/industries/biometricoffice/multiple.png";
import turnkey from "../../../assets/img/industries/biometricoffice/turnkey.png";
import realtime from "../../../assets/img/products/facialsensevisitormanagement/icon_brain_realtime_3d.png";
import locaiton from "../../../assets/img/industries/biometricoffice/locationservice.png";
import remote from "../../../assets/img/industries/biometricoffice/remoteservice_3d.png";
import identifer from "../../../assets/img/industries/biometricoffice/identifier.png";

export const Agriculture = () => {
  const { t, i18n } = useTranslation();
  const { width } = useWindowSize();

  var content;

  const contentHeading = (title, subtitle, border, text) => (
    <div>
      <h1
        className={`inline-block border-b-[10px] h-[51px] sm:text-4xl sm:h-[40px] text-5xl text-${text} font-extrabold leading-[60px] border-${border}`}
      >
        {title}
      </h1>
      {subtitle && <br />}
      {subtitle && (
        <h1
          className={`inline-block  border-b-[10px] h-[51px] sm:text-4xl sm:h-[40px] text-5xl text-${text} font-extrabold leading-[60px] border-${border}`}
        >
          {subtitle}
        </h1>
      )}
    </div>
  );

  if (width > 350) {
    content =
      i18n.language === "en"
        ? contentHeading(
            t("industries.agriculture.header"),
            undefined,
            "[#B9AAFD]",
            "white"
          )
        : contentHeading("Nông Nghiệp", undefined, "[#B9AAFD]", "white");
  } else {
    content =
      i18n.language === "en"
        ? contentHeading(
            t("industries.agriculture.nong"),
            t("industries.agriculture.nghiep"),
            "[#B9AAFD]",
            "white"
          )
        : contentHeading("Nông", "Nghiệp", "[#B9AAFD]", "white");
  }

  return (
    <>
      {/* Header */}
      <div
        className=" bg-cover bg-center h-[360px] md:h-[250px] smAndmd:h-[180px] exact1024:h-[200px]"
        style={{
          backgroundImage:
            "url('/src/assets/img/industries/biometricoffice/group.png')",
        }}
      >
        
          {i18n.language === "en" ? (
            <div className=" md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] 460sm:pt-[61px] mx-auto px-4 pt-[68px] smAndmd:pt-0 exact1024:pt-0  minxl:pt-[100px] xl:pt-[84px]">
              <h1 className={`inline-block border-b-[10px] h-[51px] text-5xl text-white font-extrabold leading-[60px] border-[#B9AAFD] sm:text-4xl sm:h-[40px]`}>
                {t("industries.agriculture.header")}
              </h1>
            </div>
          ) : (
            <div className=" md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] 460sm:pt-[51px] mx-auto px-4 pt-[68px] smAndmd:pt-0 exact1024:pt-0">
              <h1 className={`inline-block border-b-[10px] h-[51px] text-5xl text-white font-extrabold leading-[60px] border-[#B9AAFD] sm:text-4xl sm:h-[40px]`}> 
              {content}
              </h1>
            </div>
          )}
        
      </div>

      {/* Description */}
      <div className=" bg-white">
        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] py-[50px] mx-auto relative">
          <div className="ml-[10px]">
            <h1 className="text-5xl text-[#1C2045] font-extrabold max-w-[1110px] leading-[60px]">
              {i18n.language === "en" ? (
                <h1 className="text-5xl text-[#1C2045] font-extrabold leading-[60px] sm:text-4xl">
                  <span className="inline-block border-b-[10px] h-[51px] border-[var(--tree-poppy)] sm:h-[40px]">
                    {" "}
                    {t("industries.agriculture.header")}
                  </span>
                  {t("industries.agriculture.headerdes")}
                </h1>
              ) : width < 350 ? (
                <h1 className="text-5xl text-[#1C2045] font-extrabold leading-[60px] sm:text-4xl">
                  {t("industries.agriculture.headerdes")}
                  <span className="inline-block border-b-[10px] h-[51px] border-[var(--tree-poppy)] sm:h-[40px]">
                    {" "}
                    {t("industries.agriculture.nong1")}
                  </span>
                  <br />
                  <span className="inline-block border-b-[10px] h-[51px] border-[var(--tree-poppy)] sm:h-[40px]">
                    {" "}
                    {t("industries.agriculture.nghiep")}
                  </span>
                </h1>
              ) : (
                <h1 className="text-5xl text-[#1C2045] font-extrabold leading-[60px] sm:text-4xl">
                  {t("industries.agriculture.headerdes")}
                  <span className="inline-block border-b-[10px] h-[51px] border-[var(--tree-poppy)] sm:h-[40px]">
                    {" "}
                    {t("industries.agriculture.header1")}
                  </span>
                </h1>
              )}
            </h1>

            <p className="text-[#151686] font-bold leading-[25px] text-[18px] font-montserrat mt-[15px]">
              {t("industries.agriculture.thecheckid")}
            </p>
            <p className="text-[#3A505F] leading-[25px] text-[18px] font-montserrat mt-[15px]">
              {t("industries.agriculture.accurate")}
            </p>
            <p className="text-[#3A505F] leading-[25px] text-[18px] font-montserrat mt-[15px]">
              {t("industries.agriculture.whilst")}
            </p>
            <p className="text-center italic font-light text-[#3A505f] mt-[30px] relative text-[16px] md:px-[0px] px-[80px]">
              {t("industries.biometricoffice.footer")}
              <Link
                style={{ color: "#151686", textDecoration: "underline", marginLeft: "4px" }}
                to="https://www.mobile-id.vn/"
              >
                {" "}
                https://www.mobile-id.vn
              </Link>
            </p>
          </div>
        </div>
      </div>

      <QuickStart />

      {/* Feature */}
      <div className="relative">
        <img
          src={choose1}
          className="w-[574px] h-[737px] absolute top-[-50px] right-0 "
          alt=" Choose"
        />

        <div className="md:max-w-[90%] smAndmd:max-w-[90%] exact1024:max-w-[90%] max-w-[1300px] mx-auto pt-[90px] pb-[50px] flex flex-col items-center relative ">
          <Headerkeyfeatures
            underlineHeader={t("industries.healthcare.keyfeatures")}
            desHeader={t("industries.agriculture.fearuresdes")}
            descac={t("industries.retailworkforce.cac")}
            tinh={t("industries.retailworkforce.tinh")}
            check={true}
          />
          <div className=" flex relative mt-[50px] mb-[30px] md:mb-0 sm:flex-col">
            <Features
              image={realtime}
              des={t("industries.biometricoffice.realtimedes")}
              title={t("industries.biometricoffice.realtime")}
            />
            <Features
              image={multiple}
              des={t("industries.biometricoffice.multipledes")}
              title={t("industries.biometricoffice.multiple")}
            />
            <Features
              image={turnkey}
              des={t("industries.biometricoffice.turnkeydes")}
              title={t("industries.biometricoffice.turnkey")}
            />
          </div>
          <div className=" flex relative md:mt-0 mt-[50px] mb-[30px] sm:flex-col">
            <Features
              image={locaiton}
              des={t("industries.service.locationdes")}
              title={t("industries.service.location")}
            />

            <Features
              image={remote}
              des={t("industries.service.remotedes")}
              title={t("industries.service.remote")}
            />
            <Features
              image={identifer}
              des={t("industries.constructtion.identificationdes")}
              title={t("industries.constructtion.identification")}
            />
          </div>

          <p className="text-center italic font-light text-[#3A505f] relative text-[16px] md:px-[0px] px-[160px]">
            {t("industries.biometricoffice.footer")}
            <Link
              style={{ color: "#151686", textDecoration: "underline", marginLeft: "4px" }}
              to="https://checkid.mobile-id.vn"
            >
              {" "}
              https://checkid.mobile-id.vn
            </Link>
          </p>
        </div>
      </div>
      <Question />
    </>
  );
};
